import { createRoutine } from "../utils/routine.utils";
export var getRentDeposit = createRoutine("RENT_DEPOSIT_GET");
export var getRentDeposits = createRoutine("RENT_DEPOSITS_GET");
export var getRentDepositsPaged = createRoutine("RENT_DEPOSITS_GET_PAGED");
export var createRentDeposit = createRoutine("RENT_DEPOSIT_CREATE");
export var releaseRentDeposit = createRoutine("RENT_DEPOSIT_RELEASE");
export var cancelRentDeposit = createRoutine("RENT_DEPOSIT_CANCEL");
export var approveRentDeposit = createRoutine("APPROVE_RENT_DEPOSIT");
